import { Col, Divider, Modal as AntdModal, Row } from "antd";
import React from "react";
import Button from "../Button/Button";
import styled from "styled-components";
import Text from "../Text/Text";

const Modal = styled(AntdModal)`
  .ant-modal-content {
    padding: 20px 0 !important;
  }
`;

const Frame = styled.div`
  padding: 0px 24px;
`;

export enum ModalConfirmType {
  CF = "confirm",
  DEL = "delete",
}

export const ModalConfirm = ({
  title,
  description,
  type,
  open,
  toggleOpen,
  onOk,
}: {
  title: string;
  description?: string;
  type: ModalConfirmType;
  open: boolean;
  toggleOpen: () => void;
  onOk: () => void;
}) => {
  const isDelete = type === ModalConfirmType.DEL;
  return (
    <Modal
      open={open}
      okText='ทดสอบนะ'
      style={{ padding: 0 }}
      footer={null}
      // onClose={toggleOpen}
      onCancel={toggleOpen}
      closable={false}
    >
      <Frame>
        <Text level={2}>{title}</Text>
        <br />
        <Text>{description || ""}</Text>
      </Frame>
      <Divider style={{ margin: "12px 0px" }} />
      <Frame>
        <Row gutter={16} justify='end'>
          <Col span={6}>
            <Button
              title='ยกเลิก'
              typeButton={isDelete ? "border-danger" : "primary-light"}
              onClick={toggleOpen}
            />
          </Col>
          <Col span={6}>
            <Button title='ยืนยัน' typeButton={isDelete ? "danger" : "primary"} onClick={onOk} />
          </Col>
        </Row>
      </Frame>
    </Modal>
  );
};
